import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { compose, withProps, branch, renderNothing } from 'recompose';
import { graphql } from 'react-apollo';
import {
  Button,
  ButtonToolbar,
  Glyphicon,
} from 'react-bootstrap';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

import DocumentViewer from '../../documentViewer';
import ExcelTicketSummary from '../../../components/ExcelTicketSummary';
import {
  rotateButtonProps,
  withRotateButtonState,
} from '../../submissionItemViewer/containers/SubmissionItemViewer';
import { rotateClockwise } from '../../submissionItemViewer/actions';
import { getCorpAdminFeature } from '../../authentication/selectors';

const propTypes = exact({
  // eslint-disable-next-line react/no-unused-prop-types
  ticketId: PropTypes.number.isRequired,
  documentId: PropTypes.number.isRequired,
  rotateClockwiseAction: PropTypes.func.isRequired,
  uploadedFiles: PropTypes.object,
  isCorpAdmin: PropTypes.bool.isRequired,
  ...rotateButtonProps,
});


export class TicketSubmissionItemViewer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
    };

    this.handleRotateClockwise = this.handleRotateClockwise.bind(this);
    this.setSelectedIndex = this.setSelectedIndex.bind(this);
  }


  setSelectedIndex(currentImageIndex) {
    this.setState({
      currentImageIndex,
    });
  }

  async handleRotateClockwise(currentImageIndex) {
    const { startDisableRotate, stopDisableRotate, rotateClockwiseAction, documentId } = this.props;
    try {
      startDisableRotate();
      await rotateClockwiseAction(documentId, currentImageIndex);
    } finally {
      stopDisableRotate();
    }
  }

  render() {
    const { documentId, disableRotate, isCorpAdmin } = this.props;
    const { currentImageIndex } = this.state;
    return (
      <div>
        {isCorpAdmin && (
          <ButtonToolbar>
            <Button
              className="pull-right"
              disabled={disableRotate}
              bsStyle="info"
              onClick={() => { return this.handleRotateClockwise(currentImageIndex); }}
            >
              Rotate
              <Glyphicon glyph="hand-right" style={{ paddingLeft: '0.5em' }} />
            </Button>
          </ButtonToolbar>
        )}
        <DocumentViewer
          setSelectedIndex={this.setSelectedIndex}
          documentId={documentId}
        />
      </div>
    );
  }
}

TicketSubmissionItemViewer.propTypes = propTypes;

export const TicketViewerQuery = gql`
  query TicketView($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      ticket_number {
        id
        documentId: document_id
        document {
          id
          multipage
          fileCount: file_count
          uploadedFiles: uploaded_files {
            edges {
              node {
                id
                url: view_url
                contentType: content_type
                excelTicketSummary: excel_ticket_summary {
                  ...Summary
                }
              }
            }
          }
        }
      }
    }
  }
  ${ExcelTicketSummary.fragment}
`;

const withData = graphql(TicketViewerQuery);

const mapDataToProps = withProps((props) => {
  const { documentId } = props.data.ticket.ticket_number;
  const { uploadedFiles } = props.data.ticket.ticket_number.document;
  return {
    documentId,
    uploadedFiles,
  };
});

const mapStateToProps = (state) => {
  return {
    isCorpAdmin: getCorpAdminFeature(state),
  };
};

const mapDispatchToProps = {
  rotateClockwiseAction: rotateClockwise,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoTicketId = branch(
  (props) => { return props.ticketId === null; },
  renderNothing,
);

const enhance = compose(
  withNoTicketId,
  withData,
  queryMetaHandler,
  withRedux,
  mapDataToProps,
  withRotateButtonState,
  omitProps(['data']),
);

export default enhance(TicketSubmissionItemViewer);
